import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  title: '',
  description: undefined
};
const MAX_LENGTH = 2048;
const entryUrlMetadataSlice = createSlice({
  name: 'entryUrlMetadata',
  initialState,
  reducers: {
    setEntryUrlMetadata(state, action) {
      state.title = action.payload.title.substring(0, MAX_LENGTH);
      if (action.payload.description) {
        state.description = action.payload.description.substring(0, MAX_LENGTH);
      }
    }
  }
});
export const {
  setEntryUrlMetadata
} = entryUrlMetadataSlice.actions;
export default entryUrlMetadataSlice.reducer;